<template>
  <div id="app">

    <section class="hero is-fullheight"
             :class="{ 'is-info' : isHomepage }">
      <div class="hero-head">
        <nav class="navbar">
          <div class="navbar-brand">
            <a class="navbar-item">
              <router-link class="navbar-item brand-text"
                            style="font-size: 1.5rem"
                            to="/">TweetMySlides</router-link>
            </a>

            <div class="navbar-burger" 
                  @click="showDropdownNav = !showDropdownNav" 
                  :class="{ 'is-active': showDropdownNav }">
              <!-- These three spans are the burger 'bars', so need to keep them -->
              <span></span>
              <span></span>
              <span></span>
            </div>
          </div>

          <div class="navbar-menu" :class="{ 'is-active': showDropdownNav }">
            <div class="navbar-start">
              <router-link class="navbar-item"
                          active-class="is-active"
                          exact
                          to="/">Home</router-link>
              <router-link class="navbar-item"
                          active-class="is-active"
                          to="/create">Create</router-link>
              <router-link class="navbar-item"
                          active-class="is-active"
                          to="/view">View</router-link>
              <router-link class="navbar-item"
                          active-class="is-active"
                          to="/about">About</router-link>
            </div>
          </div>

        </nav>
      </div>

      <keep-alive>
        <router-view></router-view>
      </keep-alive>

      <div class="hero-foot" 
           style="position: fixed;
                  bottom: 0;
                  left: 0;
                  right: 0;
                  border-top: 1px solid #8f99a3;
                  padding: 0.3rem;">

        <div class="content has-text-centered">
          <p>
            <strong>TweetMySlides</strong> is a side-project made with 
            <span class="icon is-small has-text-danger">
              <i class="fa fa-heart"></i>
            </span>
            by            
            <a class="is-link" href="https://plumage.carrd.co/" target="_blank">Plumage</a>.         
          </p>
        </div>

      </div>

    </section>

  </div>
</template>

<script>
import Vue from 'vue'

import VueRouter from 'vue-router'

const Home = () => import(/* webpackChunkName: "home" */ './components/Home.vue')
const Create = () => import(/* webpackChunkName: "create" */ './components/Create.vue')
const View = () => import(/* webpackChunkName: "view" */ './components/View.vue')
const About = () => import(/* webpackChunkName: "about" */ './components/About.vue')

const router = new VueRouter({
  mode: 'history',
  base: __dirname,
  routes: [
    { path: '/', component: Home },
    { path: '/create', component: Create },
    { path: '/view', component: View },
    { path: '/about', component: About }
  ]
});

import VueAppInsights from 'vue-application-insights'
Vue.use(VueAppInsights, {
  id: '10104af4-31cc-447b-881f-5e36e97adaa0',
  router
})
// AppInsights obj will now be available at: this.$appInsights

// https://github.com/MatteoGabriele/vue-analytics
import VueAnalytics from 'vue-analytics';
Vue.use(VueAnalytics, {
  id: 'UA-110136713-1',
  router,
  autoTracking: {
    exception: true
  },
  debug: {
    sendHitTask: process.env.NODE_ENV === 'production'
  }
});
// Google Analytics will now be available at: this.$ga

export default {
  router,
  name: 'App',
  data () {
    return {
      showDropdownNav: false
    }
  },
  computed: {
    isHomepage() {
      return this.$route.path === '/';
    }
  },
  mounted () {
    router.beforeEach((to, from, next) => {
      this.showDropdownNav = false;
      next();
    })
  }
}
</script>

<style lang="scss">
// Customize Bulma/Buefy
// Import Bulma's core
@import "~bulma/sass/utilities/_all";

// Import Bulma and Buefy styles, and extension styles
@import "~bulma";
@import "~buefy/src/scss/buefy";

// Tooltip styles
@import "~vue-directive-tooltip/src/css/index.scss";
.vue-tooltip {
  background: white;
  border: 1px solid #b5b5b5;
  color: #4a4a4a;  
  font-size: 12px;

  .tooltip-arrow {    
    border: 1px solid #b5b5b5;
  }
}

// Import MS Fabric icons
@import '~office-ui-fabric-core/dist/sass/_References';
@import "~office-ui-fabric-core/dist/sass/_Icon.Definitions";
@import "~office-ui-fabric-core/dist/sass/_Icon";

// Our tweaks: //

.hero-body {
  padding: 0.5rem 1.5rem 3rem 1.5rem;
}

.hero-foot {
  background-color: white;
  color: #4a4a4a;
  a {
    color: #3273dc !important;
  }
}

.slide-image-modal {
  .modal-content, .modal-card {
    width: calc(100vw - 120px) !important;
  }
}

// Styles from: https://dansup.github.io/bulma-templates/templates/admin.html
html,
body {
  font-family: "Open Sans", serif;
  font-size: 16px;
  line-height: 1.5;
  height: 100%;
  background: #ecf0f3;
}

nav.navbar {
  border-top: 4px solid #276cda;
  margin-bottom: 1rem;
}

a.navbar-item.is-active:not(:hover) {
  background-color: whitesmoke;
}

.navbar-item.brand-text {
  font-weight: 300;
}

.navbar-item,
.navbar-link {
  font-size: 14px;
  font-weight: 700;
}

.columns {
  width: 100%;
  height: 100%;
}

.menu-label {
  color: #8f99a3;
  letter-spacing: 1.3;
  font-weight: 700;
}

.menu-list a {
  color: #0f1d38;
  font-size: 14px;
  font-weight: 700;
}

.menu-list a:hover {
  background-color: transparent;
  color: #276cda;
}

.menu-list a.is-active {
  background-color: transparent;
  color: #276cda;
  font-weight: 700;
}

.card {
  box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.18);
  margin-bottom: 2rem;
}

.card-header-title {
  color: #8f99a3;
  font-weight: 400;
}

.info-tiles {
  margin: 1rem 0;
}

.info-tiles .subtitle {
  font-weight: 300;
  color: #8f99a3;
}

.hero.welcome.is-info {
  background: #36d1dc;
  background: -webkit-linear-gradient(to right, #5b86e5, #36d1dc);
  background: linear-gradient(to right, #5b86e5, #36d1dc);
}

.hero.welcome .title,
.hero.welcome .subtitle {
  color: hsl(192, 17%, 99%);
}

.card .content {
  font-size: 14px;
}

.card-footer-item {
  font-size: 14px;
  font-weight: 700;
  color: #8f99a3;
}

.card-footer-item:hover {
}

.card-table .table {
  margin-bottom: 0;
}

.events-card .card-table {
  max-height: 250px;
  overflow-y: scroll;
}
</style>



// WEBPACK FOOTER //
// src/App.vue